const circularCardsData = [
  {
    id: 1,
    text: "03+",
    label: "Years",
  },
  {
    id: 2,
    text: "10+",
    label: "Events Anually",
  },
  {
    id: 3,
    text: "1K+",
    label: "Community Members",
  },
  {
    id: 4,
    text: "200+",
    label: "Attendees",
  },
];

export default circularCardsData; 
